module.exports = __webpack_public_path__ + "static/media/AlarmDark.0e958cdb.svg";